import language from '@iso/config/language.config';

import englishLang from '@iso/assets/images/flag/uk.svg';
import italianLang from '@iso/assets/images/flag/brasil.svg';

const config = {
  defaultLanguage: language,
  options: [
    
    {
      languageId: 'brasil',
      locale: 'pt',
      text: 'Português',
      icon: italianLang,
    },
    
    {
      languageId: 'english',
      locale: 'en',
      text: 'English',
      icon: englishLang,
    },
   
  ],
};

export function getCurrentLanguage(lang) {
  let selecetedLanguage = config.options[0];
  config.options.forEach(language => {
    if (language.languageId === lang) {
      selecetedLanguage = language;
    }
  });
  return selecetedLanguage;
}
export default config;
